import React, { useContext } from 'react'
import { useFormik } from 'formik'
import { ContainerNew } from 'presentation/shared/components/ContainerNew'
import { useHistory, useLocation } from 'react-router'
import HeaderNew from 'presentation/shared/components/HeaderNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { validationSchema } from './validationSchema'
import TextAreaNew from 'presentation/shared/components/TextAreaNew'
import * as S from './styles'
import { AmbulatoryAuthorizationDashboardContext } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'

type LocationProps = {
  isEditing?: boolean
}

const AmbulatoryObservationsLayout = () => {
  const history = useHistory()
  const stateLocation = useLocation()?.state as LocationProps
  const { state, dispatch } = useContext<any>(
    AmbulatoryAuthorizationDashboardContext
  )
  const { patient, observation } = state

  if (!patient?.cpf) {
    history.push('/pedidos-autorizacao-ambulatorial/solicitacao')
  }

  const formik = useFormik({
    initialValues: {
      observation: observation || ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch({
        type: 'OBSERVATIONS',
        payload: values.observation
      })

      stateLocation?.isEditing
        ? history.push('resumo#obs')
        : history.push('documentos')
    }
  }) as any

  return (
    <>
      <HeaderNew
        actualPageOnClick={() =>
          stateLocation?.isEditing ? history.push('resumo') : history.goBack()
        }
        actualPageTitle="Solicitar pedido ambulatorial"
      />

      <ContainerNew
        title="Observações"
        titleColor="neutral800"
        titleSize="large"
        titleWeight="bold"
        primaryButton={
          <ButtonNew fullWidth size="large" onClick={formik.submitForm}>
            {stateLocation?.isEditing ? 'Salvar' : 'Próximo'}
          </ButtonNew>
        }
      >
        <S.Wrapper>
          <S.FormWrapper onSubmit={formik.handleSubmit}>
            <TextAreaNew
              label="Observações"
              labelSize="xxsmall"
              labelOverlapping
              placeholder="Digite as observações"
              name="observation"
              rows={5}
              maxLength={500}
              value={formik.values.observation}
              onChange={formik.handleChange}
              error={formik.touched.observation && formik.errors.observation}
            />
          </S.FormWrapper>
        </S.Wrapper>
      </ContainerNew>
    </>
  )
}

export default AmbulatoryObservationsLayout
